import { render, staticRenderFns } from "./TaskToDetail.vue?vue&type=template&id=1cf9759d&"
import script from "./TaskToDetail.vue?vue&type=script&lang=ts&"
export * from "./TaskToDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports